import { useAppDispatch } from 'stores';
import useLoginForm from './useLoginForm';
import { login, setUser } from 'stores/auth';
import { AuthApi, MeApi, base } from 'api';
import useModal from 'hooks/useModal';

function useLogin() {
  const { handleAlert } = useModal();
  const dispatch = useAppDispatch();
  const formData = useLoginForm();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.validate()) return;
    const id = formData.idRef.current?.value || '';
    const pw = formData.pwRef.current?.value || '';

    try {
      const res = await AuthApi.login({ username: id, password: pw });
      const token = res.data.access_token;
      // /me 호출을 위해 Bearer 헤더를 수동 주입 (useAuth* 훅 바깥이라 axios 기본값에 세팅)
      base.defaults.headers.common['authorization'] = `Bearer ${token}`;
      const me = await MeApi.get();
      dispatch(login(token));
      dispatch(setUser(me.data));
    } catch {
      handleAlert('계정정보를 확인해주세요');
    }
  };

  return { ...formData, handleSubmit };
}

export default useLogin;
